import { AddressSubType, AddressType } from '../type';

export const ADDRESS_TYPE: { [k in AddressType]: string } = {
  RESIDENTIAL_ADDRESS: 'Residential Address',
  MAILING_ADDRESS: 'Mailing Address',
};

export const ADDRESS_SUB_TYPE: { [k in AddressSubType]: string } = {
  [AddressSubType.LOCAL]: 'Local Address',
  [AddressSubType.FOREIGN]: 'Foreign Address',
};

export const ADDRESS_TYPE_OPTIONS = Object.entries(ADDRESS_TYPE).map(([k, v]) => ({ value: k, label: v }));
export const ADDRESS_SUB_TYPE_OPTIONS = Object.entries(ADDRESS_SUB_TYPE).map(([k, v]) => ({ value: k, label: v }));
